<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="결제내역"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr pt25 mb25">
          <select class="ipt" id="sel" title="제품번호/상품명 선택" v-model="orderId">
            <option :value="order.orderId" v-for="(order, orderIndex) in orderList" :key="orderIndex" @change="clearRentalPayHistory">
              {{ order.orderId }} / {{ order.productName }}
            </option>
          </select>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">기간별 납부 내역</h2>
          </div>
          <div class="formArea">
            <ul class="iptGroup iptBtn">
              <li>
                <input type="radio" class="ipt" name="rdosort" id="rdo1" value="all" v-model="period" />
                <label for="rdo1">전체</label>
              </li>
              <li>
                <input type="radio" class="ipt" name="rdosort" id="rdo2" value="month1" v-model="period" />
                <label for="rdo2">1개월</label>
              </li>
              <li>
                <input type="radio" class="ipt" name="rdosort" id="rdo3" value="month3" v-model="period" />
                <label for="rdo3">3개월</label>
              </li>
              <li>
                <input type="radio" class="ipt" name="rdosort" id="rdo4" value="select" v-model="period" />
                <label for="rdo4">기간선택</label>
              </li>
            </ul>

            <div class="setHalf readonly" :style="{ display: periodFlag }">
              <div style="width:48%;margin-left:1%">
                <datepicker v-model="fromdate" v-bind:format="format" v-bind:input-class="inputClass" v-bind:language="lang"></datepicker>
              </div>
              <div style="width:2%;text-align: center;line-height: 37px;">~</div>
              <div style="width:48%;">
                <datepicker v-model="todate" v-bind:format="format" v-bind:input-class="inputClass" v-bind:language="lang"></datepicker>
              </div>
            </div>
            <button type="button" class="btn_g m" @click="searchRentalPayHistory">조회</button>
          </div>
        </section>
        <section>
          <div class="titArea">
            <span class="titH5 normal"><a class="tit link" @click="openPaymentRentalOtherPop">렌탈료 외 납부내역</a></span>
          </div>
          <div class="resultMsg txtOnly" v-if="!selectPeriod">
            <p class="copy">조회기간을 선택해주세요</p>
          </div>
          <span v-if="selectPeriod">
            <template v-if="rentalList.length == 0">
              <div class="resultMsg txtOnly">
                <p class="copy">결제내역이 없습니다.</p>
              </div>
            </template>
            <template v-else>
              <div class="tblListTit" aria-hidden="true">
                <span class="item">결제일</span>
                <span class="val">납부금액 (회차)</span>
              </div>
              <ul class="infoList tblX">
                <li v-for="(rental, index) in rentalList" :key="index">
                  <div class="accoHead">
                    <span class="item">
                      <span class="blind">결제일</span>
                      {{ rental.rcptDtDtm | dateFormatter('-') }}
                    </span>
                    <span class="val">
                      <span class="blind">납부금액 (납부회차)</span>
                      <!--10,000원-->
                      {{ rental.depositAmount | currency }}원
                      <span>({{ rental.invoiceSeq }}회차)</span>
                    </span>
                    <button type="button" class="btnIco_acco accoBtn">
                      <span>상세보기</span>
                    </button>
                  </div>
                  <div class="accoBody">
                    <ul class="infoList">
                      <li>
                        <span class="item">청구일</span>
                        <span class="val">{{ rental.demandDate | dateFormatter('-') }}</span>
                      </li>
                      <li>
                        <span class="item">청구금액</span>
                        <span class="val">{{ rental.demandAmount | currency }}원</span>
                      </li>
                      <li>
                        <span class="item">입금금액</span>
                        <span class="val">{{ rental.depositAmount | currency }}원</span>
                      </li>
                      <li>
                        <span class="item">입금일자</span>
                        <span class="val">{{ rental.rcptDtDtm | dateFormatter('-') }}</span>
                      </li>
                      <li>
                        <span class="item">미납금액</span>
                        <span class="val">{{ rental.overdueAmount | currency }}</span>
                      </li>
                      <li v-if="rental.discountType">
                        <span class="item">할인유형</span>
                        <span class="val">{{ rental.discountType }}</span>
                      </li>
                      <li v-if="rental.discountType">
                        <span class="item">할인금액</span>
                        <span class="val">{{ rental.discountAmount | currency }}원</span>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </template>
          </span>
        </section>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
      <PaymentRentalOtherPop v-if="paymentRentalOtherPop" @close="paymentRentalOtherPop = false" :orderId="orderId"></PaymentRentalOtherPop>
      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import QuickMenu from '@/views/app/comm/QuickMenu';
import CommonBanner from '@/components/banner/CommonBanner';
import PaymentRentalOtherPop from '@/views/app/mypage/payment/PaymentRentalOtherPop';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import * as customjs from '@/../static/js/m.front.js';

export default {
  name: 'PaymentHistory',
  components: {
    QuickMenu,
    CommonBanner,
    PaymentRentalOtherPop,
    Datepicker,
  },
  data: function() {
    return {
      paymentRentalOtherPop: null,
      //orderId: 'ID1812R10782',
      orderId: '',

      orderList: [],
      applyList: [],
      rentalList: [],

      period: 'all',
      periodFlag: 'none',
      disabledFlag: '',
      selectPeriod: false,
      fromdate: 'all',
      todate: 'all',
      format: 'yyyy-MM-dd',
      inputClass: 'ipt date notDel uiAct',
      //calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
    };
  },
  watch: {
    period() {
      if (this.period == 'all') {
        this.periodFlag = 'none';
        this.todate = 'all';
        this.fromdate = 'all';
      } else if (this.period == 'month1') {
        this.periodFlag = 'block';
        this.disabledFlag = 'disabled';
        this.todate = new Date();
        this.fromdate = new Date();
        this.fromdate.setMonth(this.fromdate.getMonth() - 1);
      } else if (this.period == 'month3') {
        this.periodFlag = 'block';
        this.disabledFlag = 'disabled';
        this.todate = new Date();
        this.fromdate = new Date();
        this.fromdate.setMonth(this.fromdate.getMonth() - 3);
      } else if (this.period == 'select') {
        this.periodFlag = 'block';
        this.disabledFlag = '';
        this.todate = new Date();
        this.fromdate = new Date();
      }
    },
  },
  created() {
    // this.orderId = this.$route.params.orderId;
    console.log(this.orderId);
    if (this.$route.params.orderId) this.orderId = this.$route.params.orderId;
  },
  mounted() {
    ApiService.service('GET', '/service/auth/myRentalList')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.orderList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });

    ApiService.service('GET', '/service/auth/document/' + this.orderId)
      .then(({ data }) => {
        if (data.isSucceed) {
          this.applyList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  methods: {
    openPaymentRentalOtherPop: function() {
      this.paymentRentalOtherPop = true;
    },
    searchRentalPayHistory() {
      let fromdate = this.fromdate instanceof Date ? moment(this.fromdate).format('yyyyMMDD') : this.fromdate;
      let todate = this.todate instanceof Date ? moment(this.todate).format('yyyyMMDD') : this.todate;
      console.log(fromdate + ' : ' + todate);
      ApiService.service('GET', '/service/auth/rental/payment/bydate/' + this.orderId + '/' + fromdate + '/' + todate)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.rentalList = data.result;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          customjs.accoInit(); // 상세보기 css 이벤트 위함.
        });
      this.selectPeriod = true;
    },
    clearRentalPayHistory() {
      this.rentalList = [];
    },
  },
};
</script>
